import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import { useRegistrationStore } from '../../../hooks';
import { MenuCategoryIdInput, MenuCategoryNameInput } from '../../Forms';

type Props = ReturnType<typeof useRegistrationStore>['form'] & {
  handleConfirm: () => void;
};

export const MenuCategoryRegistrationInputModalView: FC<Props> = ({
  register,
  formState,
  handleConfirm,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">カテゴリーの登録</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.id}>
          <FormLabel>カテゴリーID</FormLabel>
          <MenuCategoryIdInput name="id" register={register} w="240px" />
          <FormErrorMessage>{formState.errors.id?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.name}>
          <FormLabel>カテゴリー名</FormLabel>
          <MenuCategoryNameInput name="name" register={register} />
          <FormErrorMessage>{formState.errors.name?.message}</FormErrorMessage>
        </FormControl>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        onClick={handleConfirm}
        isDisabled={!formState.isValid}
      >
        確認
      </Button>
    </ModalFooter>
  </ModalContent>
);
